<template>
    <v-row>
        <v-col cols="12" sm="12" md="8">
            <v-card v-if="survey" outlined>
                <v-card-text>
                    <FormRenderer :form="survey.form" v-model="responses" :show-metadata="true" :disabled="submitting"
                        :title="survey.title"
                        :description="survey.description ? markdownToHtml(survey.description) : null"
                        :showSuccessMessage="submitted" ref="formRendererRef" />
                </v-card-text>
                <v-card-text v-if="!submitted">
                    <v-btn @click="submitSurvey" color="primary" :loading="submitting">
                        {{ $t('Lähetä') }}
                    </v-btn>
                    <v-alert v-if="error" color="error" text class="my-2">
                        {{ error }}
                    </v-alert>
                </v-card-text>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import * as surveyApi from "@/api/public/survey.api";
import useAuth from "@/useAuth";
import router from "@/router";
import useMarkdown from "@/@core/utils/useMarkdown";
import FormRenderer from "@/components/forms/FormRenderer.vue";

export default {
    components: {
        FormRenderer
    },
    props: ["id"],
    setup(props) {
        const { user } = useAuth();
        const { markdownToHtml } = useMarkdown();
        const survey = ref(null);
        const responses = ref({});
        const submitted = ref(false);
        const submitting = ref(false);
        const formRendererRef = ref(null);
        const error = ref(null);

        const fetchSurvey = async (id) => {
            const response = await surveyApi.getSurvey(id);

            if (response.ok) {
                survey.value = response.data;

                // Check if user has already submitted and form doesn't allow multiple submissions
                if (survey.value.replied && !survey.value.form.allow_multiple_submissions) {
                    submitted.value = true;
                }
            } else {
                console.error('Error fetching survey:', response.error);
            }
        };

        const submitSurvey = async () => {
            error.value = null;
            // Validate using FormRenderer's validate method
            if (formRendererRef.value && !formRendererRef.value.validate()) {
                return;
            }

            submitting.value = true;

            const formattedResponses = formRendererRef.value.getFormattedResponses();
            const response = await surveyApi.submitSurvey(props.id, formattedResponses);

            submitting.value = false;

            if (response.ok) {
                submitted.value = true;
            } else {
                error.value = response.error;
            }
        };

        onMounted(() => {
            if (user.value.read_only) {
                router.replace('/home');
            } else if (props.id) {
                fetchSurvey(props.id);
            }
        });

        return {
            survey,
            responses,
            submitted,
            submitting,
            error,
            formRendererRef,
            submitSurvey,
            markdownToHtml
        };
    },
};
</script>
